import { render, staticRenderFns } from "./VideoLoader.vue?vue&type=template&id=12bddd77&"
import script from "./VideoLoader.vue?vue&type=script&lang=js&"
export * from "./VideoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('12bddd77', component.options)
    } else {
      api.reload('12bddd77', component.options)
    }
    module.hot.accept("./VideoLoader.vue?vue&type=template&id=12bddd77&", function () {
      api.rerender('12bddd77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/landing-page/lib/VideoLoader.vue"
export default component.exports